import { Pipe, PipeTransform } from '@angular/core';
import { GridItem, GridColumn } from '../grid-control.model';

@Pipe({
  name: 'mobileViewHtmlTempate'
})
export class MobileViewHtmlTemplatePipe implements PipeTransform {
  transform(rowData: GridItem, columns: GridColumn[], htmlTemplate: (rowData: any, columns?: GridColumn[]) => string): string {
    return htmlTemplate(rowData, columns);
  }
}
